export const NOK_RELATIONS = [
    { value: 'Partner', label: 'Partner' },
    { value: 'Forelder', label: 'Forelder' },
    { value: 'Barn', label: 'Barn' },
    { value: 'Søsken', label: 'Søsken' },
    { value: 'Venn', label: 'Venn' },
    { value: 'Kollega', label: 'Kollega' },
    { value: 'Annet', label: 'Annet' }
];

/** Brønnøysundregisteret **/
// API-endepunkt for å søke i Enhetsregisteret
export const BRREG_ENDPOINT = 'https://data.brreg.no/enhetsregisteret/api/enheter';

// Organisasjonsformer
// Disse er relevante for oss å vise i søk
export const BRREG_ORGFORM_KODER = [
    'ADOS', // Administrativ enhet - offentlig sektor
    'ANNA', // Annen juridisk person
    'ANS', // Ansvarlig selskap med solidarisk ansvar
    'AS', // Aksjeselskap
    'ASA', // Allmennaksjeselskap
    'BA', // Selskap med begrenset ansvar
    'BEDR', // Underenhet til næringsdrivende og offentlig forvaltning
    'DA', // Ansvarlig selskap med delt ansvar
    'ENK', // Enkeltpersonforetak
    'EOFG', // Europeisk økonomisk foretaksgruppe
    'FKF', // Fylkeskommunalt foretak
    'FYLK', // Fylkeskommune
    'GFS', // Gjensidig forsikringsselskap
    'IKS', // Interkommunalt selskap
    'KF', // Kommunalt foretak
    'KIRK', // Den norske kirke
    'KOMM', // Kommune
    'KS', // Kommandittselskap
    'NUF', // Norskregistrert utenlandsk foretak
    'OPMV', // Særskilt oppdelt enhet
    'ORGL', // Organisasjonsledd
    'PRE', // Partrederi
    'SA', // Samvirkeforetak
    'SE', // Europeisk selskap
    'SF', // Statsforetak
    'SPA', // Sparebank
    'STAT', // Stat
    'STI', // Stiftelse
    'SÆR', // Annet foretak iflg. særskilt lov
    'UTLA' // Utenlandsk enhet
];

// Disse har vi ingen interesse av å vise i søk
export const BRREG_ORGFORM_KODER_IKKE_BRUK = [
    'AAFY', // Underenhet til ikke-næringsdrivende
    'BBL', // Boligbyggelag
    'BO', // Andre bo
    'BRL', // Borettslag
    'ESEK', // Eierseksjonssameie
    'FLI', // Forening/lag/innretning
    'IKJP', // Andre ikke-juridiske personer
    'KBO', // Konkursbo
    'KTRF', // Kontorfellesskap
    'PERS', // Andre enkeltpersoner som registreres i tilknyttet register
    'PK', // Pensjonskasse
    'SAM', // Tingsrettslig sameie
    'TVAM', // Tvangsregistrert for MVA
    'VPFO' // Verdipapirfond
];
